import { MultilingualFormInput } from "@components/forms/multilingual";

const inputs: MultilingualFormInput[] = [
    {
        name: "title",
        label: "Title",
        rules: [{ required: true, message: "Please insert a title" }]
    },
    {
        name: "subtitle",
        label: "Subtitle"
    }
];

export default inputs;
